import React, {useState, useEffect} from 'react'
import { NavLink } from "react-router-dom";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import {
  Home,
  Executive,
  Operations,
  Transcribe,
  Compliance,
  Complaints,
  AgentEffectiveness,
  Footer,
  ComplaintsDetailed,
  LiveDiarization,
  MockWamAgentEffectiveness
} from "./components";
// import { theme as AssetTheme } from './theme';

// Import MUI elements
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Switch from '@mui/material/Switch';
import Toolbar from '@mui/material/Toolbar';

// Import icons
import AssessmentIcon from '@mui/icons-material/Assessment';
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import FeedbackIcon from '@mui/icons-material/Feedback';
import HomeIcon from '@mui/icons-material/Home';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import ListItemIcon from '@mui/material/ListItemIcon';
import MenuIcon from '@mui/icons-material/Menu';
import NetworkCheckIcon from '@mui/icons-material/NetworkCheck';
import SpeedIcon from '@mui/icons-material/Speed';
import TranscribeIcon from '@mui/icons-material/Transcribe';
import MicIcon from '@mui/icons-material/Mic';

const navItems = [["Home", "/"], ["Executive", "/executive"], ["Operations", "/operations"], ["Transcribe", "/transcribe"], ["Compliance", "/compliance"], ["Complaints", "/complaints"], ["Agent Effectiveness", "/agenteffectiveness"], ["Live Diarization", "/livediarization"], ["Mock WAM Agent", "/mockwamagent"], ["Additional Insights", "http://4.156.185.204:8050/ConsumerBanking/"]];
const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerWindow = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
          '#fff',
        )}" d="M4.2 2.5l-.7 1.8-1.8.7 1.8.7.7 1.8.6-1.8L6.7 5l-1.9-.7-.6-1.8zm15 8.3a6.7 6.7 0 11-6.6-6.6 5.8 5.8 0 006.6 6.6z"/></svg>')`,
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? '#003892' : '#001e3c',
    width: 32,
    height: 32,
    '&::before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
        '#fff',
      )}" d="M9.305 1.667V3.75h1.389V1.667h-1.39zm-4.707 1.95l-.982.982L5.09 6.072l.982-.982-1.473-1.473zm10.802 0L13.927 5.09l.982.982 1.473-1.473-.982-.982zM10 5.139a4.872 4.872 0 00-4.862 4.86A4.872 4.872 0 0010 14.862 4.872 4.872 0 0014.86 10 4.872 4.872 0 0010 5.139zm0 1.389A3.462 3.462 0 0113.471 10a3.462 3.462 0 01-3.473 3.472A3.462 3.462 0 016.527 10 3.462 3.462 0 0110 6.528zM1.665 9.305v1.39h2.083v-1.39H1.666zm14.583 0v1.39h2.084v-1.39h-2.084zM5.09 13.928L3.616 15.4l.982.982 1.473-1.473-.982-.982zm9.82 0l-.982.982 1.473 1.473.982-.982-1.473-1.473zM9.305 16.25v2.083h1.389V16.25h-1.39z"/></svg>')`,
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
    borderRadius: 20 / 2,
  },
}));

function App() {
  return (
    <Router>
      <Main />
    </Router>
  );
}

function Main() {

  const location = useLocation();
  const currentPath = location.pathname;

  let pageTitle = '';
  switch (currentPath) {
    case '/':
      pageTitle = 'AI Voice Analytics';
      break;
    case '/executive':
      pageTitle = 'Contact Center Operations > Executive View';
      break;
    case '/operations':
      pageTitle = 'Contact Center Operations > Operations Manager Overview';
      break;
    case '/transcribe':
      pageTitle = 'Contact Center Operations > Transcribe Calls (Demo)';
      break;
    case '/compliance':
      pageTitle = 'Contact Center Operations > Compliance Disclosure';
      break;
    case '/complaints':
      pageTitle = 'Contact Center Operations > Complaints Management';
      break;
    case '/agenteffectiveness':
      pageTitle = 'Contact Center Operations > Agent Effectiveness Overview';
      break;
    case '/livediarization':
      pageTitle = 'Contact Center Operations > Live Diarization & Intent';
      break;
    case '/mockwamagent':
      pageTitle = 'Wealth Management > Advisor Effectiveness';
      break;
    default:
      pageTitle = '';
  }

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const mobileDrawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <div className='mobile-drawer-header'>
        <List>
          {navItems.map((item) => (
            <NavLink key={item[0] + '-nav'} className="nav-link" to={item[1]}>
              <ListItem key={item} disablePadding>
                <ListItemButton sx={{ textAlign: 'center' }}>
                  <ListItemText primary={item[0]} />
                </ListItemButton>
              </ListItem>
            </NavLink>
          ))}
        </List>
      </div>
    </Box>
  );

  const [mode, setMode] = useState('light')

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const onSelectMode = (mode) => {
    setMode(mode)
    if (mode === 'dark')
      document.body.classList.add('dark-mode')
    else
      document.body.classList.remove('dark-mode')
  }

  useEffect(() => {
    // Add listener to update styles
    window.matchMedia('(prefers-color-scheme: light)').addEventListener('change', e => onSelectMode(e.matches ? 'light' : 'dark'));
  
    // Setup dark/light mode for the first time
    onSelectMode(window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark')
  
    // Remove listener
    return () => {
      window.matchMedia('(prefers-color-scheme: light)').removeEventListener('change', () => {
      });
    }
  }, []);

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      {windowWidth < 600 ? (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar component="nav">
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon  className='menu-icon-btn'/>
            </IconButton>
            {/* <img src={AssetTheme.images.logo.dark} alt="Site Logo" className='app-nav-logo'/> */}
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              {navItems.map((item) => (
                <NavLink key={item[0] + '-nav'} className="nav-link" to={item[1]}>
                  <Button key={item} sx={{ color: '#fff' }}>
                    {item[0]}
                  </Button>
                </NavLink>
              ))}
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {mobileDrawer}
          </Drawer>
        </nav>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/executive" element={<Executive parentToChild={{mode}}/>} />
              <Route path="/operations" element={<Operations parentToChild={{mode}}/>} />
              <Route path="/transcribe" element={<Transcribe parentToChild={{mode}}/>} />
              <Route path="/compliance" element={<Compliance parentToChild={{mode}}/>} />
              <Route path="/complaints" element={<Complaints parentToChild={{mode}}/>} />
              <Route path="/agenteffectiveness" element={<AgentEffectiveness parentToChild={{mode}}/>} />
              <Route path="/complaints/detailed" element={<ComplaintsDetailed parentToChild={{mode}}/>} />
              <Route path="/livediarization" element={<LiveDiarization parentToChild={{mode}}/>} />
              <Route path="/mockwamagent" element={<MockWamAgentEffectiveness parentToChild={{mode}}/>} />
          </Routes>
          <Footer parentToChild={{mode}}/>
          <FormGroup className="mui-switch-toggle">
            <FormControlLabel
              control={<MaterialUISwitch sx={{ m: 1 }} defaultChecked />}
              onClick={() => mode === 'light' ? onSelectMode('dark') : onSelectMode('light')}
            />
          </FormGroup>
        </Box>
      </Box>
      ) : (
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar component="nav" className="nav-bar" position="fixed" open={open}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon className='menu-icon-btn' />
            </IconButton>
            {/* <img src={AssetTheme.images.logo.dark} alt="Site Logo" className='app-nav-logo'/> */}
            <h1 className='nav-title'>{pageTitle}</h1>
          </Toolbar>
        </AppBar>
        <DrawerWindow className="drawer-nav-bar" variant="permanent" open={open}>
          <DrawerHeader>
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === 'rtl' ? <ChevronRightIcon /> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <Divider />
          <List className="nav-bar">
            {navItems.map((item) => (
              <NavLink key={item[0] + '-nav'} className="nav-link" underline="hover" to={item[1]}>
                <ListItem key={item[0] + '-li'} disablePadding sx={{ display: 'block' }}>
                  <ListItemButton
                    key={item[0]}
                    sx={{
                      minHeight: 48,
                      justifyContent: open ? 'initial' : 'center',
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      key={item[0] + '-list-icon'}
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : 'auto',
                        justifyContent: 'center',
                      }}
                    >
                    { item[0] === 'Home' && <HomeIcon />}
                    { item[0] === 'Executive' && <NetworkCheckIcon />}
                    { item[0] === 'Operations' && <SpeedIcon />}
                    { item[0] === 'Transcribe' && <TranscribeIcon />}
                    { item[0] === 'Compliance' && <AssuredWorkloadIcon />}
                    { item[0] === 'Complaints' && <FeedbackIcon />}
                    { item[0] === 'Agent Effectiveness' && <AssessmentIcon />}
                    { item[0] === 'Live Diarization' && <MicIcon />}
                    { item[0] === 'Mock WAM Agent' && <LeaderboardIcon />}
                    { item[0] === 'Additional Insights' && <LeaderboardIcon />}
                    </ListItemIcon>
                    <ListItemText key={item[0]+ '-li-text'} primary={item[0]} sx={{ opacity: open ? 1 : 0 }} />
                  </ListItemButton>
                </ListItem>
              </NavLink>
            ))}
          </List>
        </DrawerWindow>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />
          <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/executive" element={<Executive parentToChild={{mode}}/>} />
              <Route path="/operations" element={<Operations parentToChild={{mode}}/>} />
              <Route path="/transcribe" element={<Transcribe parentToChild={{mode}}/>} />
              <Route path="/compliance" element={<Compliance parentToChild={{mode}}/>} />
              <Route path="/complaints" element={<Complaints parentToChild={{mode}}/>} />
              <Route path="/agenteffectiveness" element={<AgentEffectiveness parentToChild={{mode}}/>} />
              <Route path="/complaints/detailed" element={<ComplaintsDetailed parentToChild={{mode}}/>} />
              <Route path="/livediarization" element={<LiveDiarization parentToChild={{mode}}/>} />
              <Route path="/mockwamagent" element={<MockWamAgentEffectiveness parentToChild={{mode}}/>} />
          </Routes>
          <Footer parentToChild={{mode}}/>
          <FormGroup className="mui-switch-toggle">
            <FormControlLabel
              control={<MaterialUISwitch sx={{ m: 1 }} defaultChecked />}
              onClick={() => mode === 'light' ? onSelectMode('dark') : onSelectMode('light')}
            />
          </FormGroup>
        </Box>
      </Box>
    )}
  </>
  )
}

export default App;